// Copies text to clipboard

var $           = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
var Clipboard   = require('clipboard');

module.exports = (function() {

    var init = function() {
        $('.share-copy-link').on('click', function(event) {
            event.preventDefault();
        });

        var clipboard = new Clipboard('.share-copy-link');
    };

    return {
        init: init
    };
})();
